module.exports = __webpack_public_path__ + "static/media/user_sample_excel.88b445a6.JPG";


//////////////////
// WEBPACK FOOTER
// ./src/sample/user_sample_excel.JPG
// module id = 1405
// module chunks = 1